import * as React from "react";

import { UitkText } from "uitk-react-text";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";

import { getDirectDistance } from "components/flexComponents/Hotels/views/HotelsViews/HotelUtils";
import { DirectDistanceProps } from "src/components/flexComponents/Hotels/typings";

const DirectDistance = (props: DirectDistanceProps) => {
  const { hotel, className, context, showIcon = true } = props;
  const directDistance = getDirectDistance(hotel, context);

  if (!directDistance) {
    return null;
  }

  return (
    <UitkText size={300} className={className}>
      {showIcon && <UitkIcon className="distance-icon" size={UitkIconSize.SMALL} name="place" />}
      <span className="all-l-margin-one">{directDistance}</span>
    </UitkText>
  );
};

export default DirectDistance;
